import _ from 'lodash'
import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import { UrlEncodeHook } from '../../../../hooks'

const PremiumMembership = () => {
  const { urlEncode } = UrlEncodeHook()
  const history = useHistory()
  const { user } = useSelector((state) => state.Login)
  const userData = useSelector((state) => state.Login)

  return (
    <div className='premier-unlock mb-3'>
      <Row className='d-flex justify-content-center'>
        <Col
          md='8'
          className='border border-info text-dark rounded-2 py-2 px-2 text-center view-box'
        >
          <Row>
            <Col
              lg='9'
              md='9'
              sm='9'
              xs='12'
              className=' d-flex align-items-center justify-content-center'
            >
              <h4 className='mb-0'>
                <strong className='text-danger'>
                  Unlock exclusive access! Join our premier membership today!
                </strong>
              </h4>
            </Col>
            <Col lg='3' md='3' sm='3' sx='3'>
              {_.size(userData.planList) &&
              !_.every(userData.planList, ['plan_expired', 0]) ? (
                <button
                  type='button'
                  className='ms-2 btn btn-success btn-sm'
                  onClick={() => {
                    // Determine plan type from expired plans, default to premier (1)
                    let planType = 1 // Default to premier
                    if (_.size(userData.planList)) {
                      const expiredPlan = _.find(userData.planList, (plan) => plan.plan_expired !== 0)
                      if (expiredPlan) {
                        // Map plan_type to plan type number
                        if (expiredPlan.plan_type === 'premier') planType = 1
                        else if (expiredPlan.plan_type === 'herd') planType = 2
                        else if (expiredPlan.plan_type === 'combined') planType = 3
                      }
                    }
                    // Navigate with plan type parameter
                    history.push(`/premier-membership-renew/checkout?p=${urlEncode(planType)}`)
                  }}
                  title='Renew Premier Plan'
                >
                  RENEW PREMIER PLAN
                </button>
              ) : (
                <Link
                  className='btn btn-sm btn-info'
                  to={
                    user?.id
                      ? '/premier-membership-auth'
                      : '/premier-membership'
                  }
                  title='Find Out More'
                >
                  FIND OUT MORE
                </Link>
              )}

              {/* <Button color='info' size='sm'>
                JOIN NOW
              </Button> */}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default PremiumMembership